module.exports = __webpack_public_path__ + "static/fonts/MyriadPro-BoldIt.5fea8b2.woff";